import axios from 'axios';

export const sendMessage = async (formData) => {
  const response = await axios.post('http://localhost:5000/api/messages', formData);
  return response.data;
};
